import React, { useState } from "react";
import AdminHeader from "./AdminHeader"; //AdminHeader is an external component in the same directory (./AdminHeader.jsx).
import API_BASE_URL from "./api"; //API_BASE_URL is imported from a local file (./api.js) that likely contains the base URL for the backend API. This allows for easy configuration of the API endpoint across the application.
function genId() {
    return Math.random().toString(36).slice(2, 9);
}

const defaultSections = [
    {
        id: genId(),
        title: "Important Details",
        rows: [
            { id: genId(), key: "result_date", value: "" },
            { id: genId(), key: "Location", value: "" }
        ]
    }
];

export default function AdminAdmitCardEntry() {
    const [courseName, setCourseName] = useState("");
    const [instName, setInstName] = useState("");
    const [admissionType, setAdmissionType] = useState("");

    const [applStartDate, setApplStartDate] = useState("");
    const [applLastDate, setApplLastDate] = useState("");
    const [entranceExamDate, setEntranceExamDate] = useState("");

    const [applyLink, setApplyLink] = useState("");
    const [notificationPdf, setNotificationPdf] = useState("");

    const [sections, setSections] = useState(defaultSections);
    const [message, setMessage] = useState("");

    // --------------------- BUILD JSON ---------------------------
    const buildJson = () => {
        const json = {
            course_name: courseName,
            institution_name: instName,
            admission_type: admissionType,
            application_start_date: applStartDate,
            application_last_date: applLastDate,
            entrance_exam_date: entranceExamDate,
            apply_link: applyLink,
            notification_pdf: notificationPdf,
            sections: {}
        };

        for (const s of sections) {
            const sec = {};
            for (const r of s.rows) {
                sec[r.key || r.id] = r.value;
            }
            json.sections[s.title] = sec;
        }

        return json;
    }
    // ------------------------------------------------------------
    const addSection = () =>
        setSections(prev => [
            ...prev,
            {
                id: genId(),
                title: "New Section",
                rows: [{ id: genId(), key: "key1", value: "" }]
            }
        ]);

    const removeSection = id =>
        setSections(prev => prev.filter(sec => sec.id !== id));

    const addRow = sectionId =>
        setSections(prev =>
            prev.map(sec =>
                sec.id === sectionId
                    ? {
                        ...sec,
                        rows: [...sec.rows, { id: genId(), key: "", value: "" }]
                    }
                    : sec
            )
        );

    const removeRow = (sectionId, rowId) =>
        setSections(prev =>
            prev.map(sec =>
                sec.id === sectionId
                    ? { ...sec, rows: sec.rows.filter(r => r.id !== rowId) }
                    : sec
            )
        );

    const updateRow = (sectionId, rowId, field, value) =>
        setSections(prev =>
            prev.map(sec =>
                sec.id === sectionId
                    ? {
                        ...sec,
                        rows: sec.rows.map(r =>
                            r.id === rowId ? { ...r, [field]: value } : r
                        )
                    }
                    : sec
            )
        );
    // --------------------- SUBMIT ---------------------

    const handleSubmit = async () => {
        try {

            const userEmail = localStorage.getItem("userEmail");
            const user_mobileno = localStorage.getItem("user_mobileno");

            if (!userEmail || !user_mobileno) {
                alert("Login details missing. Please login again.");
                return;
            }

            const payload = {
                ...buildJson(),
                //userEmail: userEmail,
                user_mobileno: user_mobileno
            };


           // const payload = buildJson();

            const response = await fetch(
                `${API_BASE_URL}/api/admissions/submit`,
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload)
                }
            );

            const data = await response.json();

            if (data.success) {
                setMessage("Admission entry submitted successfully!");
                alert("Admission entry submitted successfully!");
            } else {
                alert("Error: " + data.message);
            }
        } catch (err) {
            alert("Network Error: " + err.message);
        }
    };

    // --------------------- UI ---------------------
    return (
        <div>
            <AdminHeader />

            <main
                style={{
                    padding: 20,
                    marginTop: 72,
                    display: "grid",
                    gridTemplateColumns: "1fr 380px",
                    gap: 16
                }}
            >
                {/* LEFT SIDE */}
                <section>
                    <h2>Admission Entry</h2>

                    <label>Course Name</label>
                    <input
                        value={courseName}
                        onChange={e => setCourseName(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Institution Name</label>
                    <input
                        value={instName}
                        onChange={e => setInstName(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Admission Type</label>
                    <input
                        value={admissionType}
                        onChange={e => setAdmissionType(e.target.value)}
                        placeholder="UG / PG / Diploma / Certificate"
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Application Start Date</label>
                    <input
                        type="date"
                        value={applStartDate}
                        onChange={e => setApplStartDate(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Application Last Date</label>
                    <input
                        type="date"
                        value={applLastDate}
                        onChange={e => setApplLastDate(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Entrance Exam Date</label>
                    <input
                        type="date"
                        value={entranceExamDate}
                        onChange={e => setEntranceExamDate(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Apply Link</label>
                    <input
                        value={applyLink}
                        onChange={e => setApplyLink(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />

                    <label>Notification PDF Link</label>
                    <input
                        value={notificationPdf}
                        onChange={e => setNotificationPdf(e.target.value)}
                        style={{ width: "100%", padding: 8, marginBottom: 10 }}
                    />
                    {/* SECTIONS */}
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                        }}
                    >
                        <h3>Sections</h3>
                        <button onClick={addSection}>+ Add Section</button>
                    </div>

                    {sections.map(s => (
                        <div
                            key={s.id}
                            style={{
                                border: "1px solid #ddd",
                                padding: 10,
                                marginBottom: 10,
                                background: "#fff"
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}
                            >
                                <input
                                    value={s.title}
                                    onChange={e =>
                                        setSections(prev =>
                                            prev.map(x =>
                                                x.id === s.id ? { ...x, title: e.target.value } : x
                                            )
                                        )
                                    }
                                    style={{ fontWeight: "bold" }}
                                />
                                <div>
                                    <button
                                        onClick={() => addRow(s.id)}
                                        style={{ marginRight: 8 }}
                                    >
                                        + Row
                                    </button>
                                    <button
                                        onClick={() => removeSection(s.id)}
                                        style={{ color: "red" }}
                                    >
                                        Remove
                                    </button>
                                </div>
                            </div>

                            {/* Rows */}
                            <div style={{ marginTop: 8 }}>
                                {s.rows.map(r => (
                                    <div
                                        key={r.id}
                                        style={{
                                            display: "flex",
                                            gap: 8,
                                            marginBottom: 6
                                        }}
                                    >
                                        <input
                                            placeholder="key"
                                            value={r.key}
                                            onChange={e =>
                                                updateRow(s.id, r.id, "key", e.target.value)
                                            }
                                            style={{ width: "40%", padding: 6 }}
                                        />
                                        <input
                                            placeholder="value"
                                            value={r.value}
                                            onChange={e =>
                                                updateRow(s.id, r.id, "value", e.target.value)
                                            }
                                            style={{ width: "50%", padding: 6 }}
                                        />
                                        <button
                                            onClick={() => removeRow(s.id, r.id)}
                                            style={{ color: "red" }}
                                        >
                                            x
                                        </button>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}

                    <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
                        <button onClick={handleSubmit}>
                            Submit Admission
                        </button>

                        <button
                            onClick={() => {
                                setSections(defaultSections);

                                setCourseName("");
                                setInstName("");
                                setAdmissionType("");

                                setApplStartDate("");
                                setApplLastDate("");
                                setEntranceExamDate("");

                                setApplyLink("");
                                setNotificationPdf("");

                                setMessage("");
                            }}
                        >
                            Reset
                        </button>
                    </div>

                    {message && (
                        <div
                            style={{
                                marginTop: 10,
                                padding: 10,
                                background: "#ecfdf5",
                                border: "1px solid #10b981",
                                borderRadius: 6
                            }}
                        >
                            {message}
                        </div>
                    )}


                </section>



                {/* RIGHT SIDE */}
                <aside>
                    <h3>JSON Preview</h3>
                    <pre
                        style={{
                            whiteSpace: "pre-wrap",
                            background: "#111",
                            color: "#b7f5d7",
                            padding: 12,
                            borderRadius: 6,
                            height: "60vh",
                            overflow: "auto"
                        }}
                    >
                        {JSON.stringify(buildJson(), null, 2)}
                    </pre>

                    <h3>Preview</h3>
                    <div
                        style={{
                            border: "1px solid #ddd",
                            padding: 8,
                            background: "#fff",
                            borderRadius: 6
                        }}
                    >

                    </div>
                </aside>
            </main>
        </div>
    );

}